<ng-container>
  <!-- <h5 class="mb-4 mx-auto text-center" *ngIf="showTitle">{{contact.type==0?"扫一扫添加客服微信":"在线客服"}} </h5>
  <div class="text-center d-flex" style="align-items: center; justify-content: center">
    <div class="wechat-helper" *ngFor="let item of contact.list">
      <img class="mb-2" src="{{item.img}}" width="100px" *ngIf="contact.type ==0" />
      <a (click)="showContact(item)" *ngIf="contact.type ==1" class="clickcontact">点击联系</a>
      <div>{{item.name}}</div>
      <div class="" *ngIf="showTime">{{item.time}}</div>
    </div>
  </div> -->

  <!-- <h5 class="mb-4 mx-auto text-center" *ngIf="showTitle">点击联系电报客服</h5>
  <div class="text-center d-flex" style="align-items: center; justify-content: center">
    <div class="telegram-helper">
      <a target="_blank" href="{{teleContact.link}}" class="clickcontact no-border">
        <img class="mb-2" src="{{teleContact.img}}" width="100px" />
      </a>
      <div class="" *ngIf="showTime">{{teleContact.time}}</div>
    </div>
  </div> -->

  <div *ngIf="!onlyIcon" class="text-center d-flex" style="align-items: center; justify-content: center">
    <div class="mr-3" *ngFor="let item of customerServiceList">
      <a *ngIf="item.LinkURL && !hasTemp(item.LinkURL)" target="_blank" href="{{item.LinkURL}}" class="clickcontact no-border">
        <img class="mb-2" src="{{item.Image}}" width="100px" alt="联系客服" loading="lazy" />
      </a>
      <a *ngIf="item.LinkURL && hasTemp(item.LinkURL)" href="javascript: void(0)"
        (click)="openStickyChat(item.LinkURL)" class="clickcontact no-border">
        <img class="mb-2" src="{{item.Image}}" width="100px" alt="联系客服"  />
      </a>
      <img *ngIf="!item.LinkURL" class="mb-2" src="{{item.Image|absUrl}}" width="100px" loading="lazy" />
      <h5 class="mb-2" [innerHtml]="item.Txt"></h5>
    </div>
  </div>

  <div *ngIf="onlyIcon" class="text-center d-flex h-100" style="align-items: center; justify-content: center">
    <div class="customer-service-icon" *ngIf="!onlyImg">
      <a [routerLink]="cusContact.link" class="clickcontact no-border">
        <img class="mb-2" src="{{cusContact.img|absUrl}}" width="100px" alt="联系客服" loading="lazy"  />
      </a>
    </div>
    <div class="customer-service-box" *ngIf="onlyImg">
      <a [routerLink]="cusContact.link" class="cs-box">
        <img class="mb-2 d-block" width="56px" height="56px" src="{{'./assets/images/footer/customer.png' | absUrl}}" alt="联系客服" loading="lazy" />
        <div class="cs-title">联系客服</div>
      </a>
    </div>
  </div>

</ng-container>

<!-- <ng-container *ngIf="contact.type ==1">

  <h5 class="mb-4" *ngIf="showTitle"></h5>
  <div class="text-center d-flex" style="align-items: center; justify-content: center">
    <div class="wechat-helper" *ngFor="let item of contact.list">
      <a href="">点击联系</a>
      <div>{{item.name}}}</div>
    </div>
  </div>
</ng-container> -->
